export function uiCodemirrorDirective(scope, iElement, iAttrs, ngModel,$rootScope, $timeout, uiCodemirrorConfig) {
    function newCodemirrorEditor(iElement, codemirrorOptions) {
        var codemirrot;
        iElement.html('');
        codemirrot = window.CodeMirror.MergeView(iElement[0], codemirrorOptions);
        return codemirrot;
    }

    function configOptionsWatcher(codemirrot, uiCodemirrorAttr, scope) {
        if (!uiCodemirrorAttr) { return; }
        var codemirrorDefaultsKeys = Object.keys(window.CodeMirror.defaults);
        scope.$watch(uiCodemirrorAttr, updateOptions, true);
        function updateOptions(newValues, oldValue) {
            if (!angular.isObject(newValues)) { return; }
            codemirrorDefaultsKeys.forEach(function (key) {
                if (newValues.hasOwnProperty(key)) {
                    if (oldValue && newValues[key] === oldValue[key]) {
                        return;
                    }
                    codemirrot.setOption(key, newValues[key]);
                }
            });
        }
    }

    function configNgModelLink(codemirror, ngModel, scope) {
        if (!ngModel) { return; }
        ngModel.$formatters.push(function (value) {
            if (angular.isUndefined(value) || value === null) {
                return '';
            } else if (angular.isObject(value) || angular.isArray(value)) {
                throw new Error('ui-codemirror cannot use an object or an array as a model');
            }
            return value;
        });

        // Override the ngModelController $render method, which is what gets called when the model is updated.
        ngModel.$render = function () {
            var safeViewValue = ngModel.$viewValue || '';
            codemirror.edit.setValue(safeViewValue);
            $timeout(() => { codemirror.right.forceUpdate("full"); }, 50);
        };

        // update ngModel from CodeMirror
        codemirror.edit.on('change', function (instance) {
            var newValue = instance.getValue();
            if (newValue !== ngModel.$viewValue) {
                ngModel.$setViewValue(newValue);
            }
        });
    }

    function configUiRefreshAttribute(codeMirror, uiRefreshAttr, scope) {
        if (!uiRefreshAttr) { return; }
        scope.$watch(uiRefreshAttr, function (newVal, oldVal) {
            // Skip the initial watch firing
            if (newVal !== oldVal) {
                codeMirror.refresh();
            }
        });
    }
    if (angular.isUndefined(window.CodeMirror)) {
        throw new Error('ui-codemirror needs CodeMirror to work...');
    }
    const codemirrorOptions = angular.extend(
        { value: iElement.text() },
        uiCodemirrorConfig.codemirror || {},
        scope.$eval(iAttrs.uiCodemirror),
        scope.$eval(iAttrs.uiCodemirrorOpts));
    const codemirror = newCodemirrorEditor(iElement, codemirrorOptions);
    configOptionsWatcher(codemirror, iAttrs.uiCodemirror || iAttrs.uiCodemirrorOpts, scope );
    configNgModelLink(codemirror, ngModel, scope);
    configUiRefreshAttribute(codemirror, iAttrs.uiRefresh, scope);
    scope.$on('CodeMirror', function (event, callback) {
        if (angular.isFunction(callback)) {
            callback(codemirror);
        } else {
            throw new Error('the CodeMirror event requires a callback function');
        }
    });
    if (angular.isFunction(codemirrorOptions.onLoad)) {
        codemirrorOptions.onLoad(codemirror);
    }
    $rootScope.codemirror = codemirror;
}



// WEBPACK FOOTER //
// ./src/app/common/directives/uiCodemirrorDirective.js